/**
 * 全局自定义组件（使用频率高的组件）
 */
import Vue from 'vue';
import PageTitle from '../components/PageTitle.vue';
import PageTopBar from '../components/PageTopBar.vue';
import PageBody from '../components/PageBody.vue';

Vue.component('PageTitle', PageTitle);
Vue.component('PageTopBar', PageTopBar);
Vue.component('PageBody', PageBody);
